// type MSElement = Element & {msRequestFullscreen: () => void }
interface CrossBrowserFullScreenableElement extends Element {
  msRequestFullscreen?: () => void;
  mozRequestFullScreen?: () => void;
  webkitRequestFullscreen?: () => void;
}

interface WebkitFullScreenDocumentObject extends Document {
  webkitExitFullscreen?: () => void;
  webkitCurrentFullScreenElement?: CrossBrowserFullScreenableElement | null;
  webkitFullScreenKeyboardInputAllowed?: boolean;
  webkitFullscreenElement?: CrossBrowserFullScreenableElement | null;
  webkitFullscreenEnabled?: boolean;
  webkitIsFullScreen?: boolean;
}

interface msFullScreenDocumentObject extends Document {
  msExitFullscreen?: () => void;
  msCurrentFullScreenElement?: CrossBrowserFullScreenableElement | null;
  msFullScreenKeyboardInputAllowed?: boolean;
  msFullscreenElement?: CrossBrowserFullScreenableElement | null;
  msFullscreenEnabled?: boolean;
  msIsFullScreen?: boolean;
}

interface mozFullScreenDocumentObject extends Document {
  mozExitFullscreen?: () => void;
  mozCurrentFullScreenElement?: CrossBrowserFullScreenableElement | null;
  mozFullScreenKeyboardInputAllowed?: boolean;
  mozFullScreenElement?: CrossBrowserFullScreenableElement | null;
  mozFullScreenEnabled?: boolean;
  mozIsFullScreen?: boolean;
}

interface CrossBrowserFullScreenableDocument
  extends WebkitFullScreenDocumentObject,
    mozFullScreenDocumentObject,
    msFullScreenDocumentObject,
    Document {
  msExitFullscreen?: () => void;
  webkitExitFullscreen?: () => void;
  mozExitFullScreen?: () => void;
}

const CrossBrowserFullScreenUtils = {
  isFullScreen: () => {
    let result = false;
    const modifiedDoc: CrossBrowserFullScreenableDocument = document;

    if (modifiedDoc.fullscreenElement) {
      result = !!modifiedDoc.fullscreenElement;
    } else if (modifiedDoc.msFullscreenElement) {
      result = !!modifiedDoc.msFullscreenElement;
    } else if (modifiedDoc.mozFullScreenElement) {
      result = !!modifiedDoc.mozFullScreenElement;
    } else if (modifiedDoc.webkitIsFullScreen) {
      result = modifiedDoc.webkitIsFullScreen;
    }
    return result;
  },

  getFullScreenElement: () => {
    let fullScreenElement;
    const modDocument: CrossBrowserFullScreenableDocument = document;
    if (document.fullscreenElement) {
      fullScreenElement = document.fullscreenElement;
    } else if (modDocument.webkitCurrentFullScreenElement) {
      fullScreenElement = modDocument.webkitCurrentFullScreenElement;
    } else if (modDocument.mozFullScreenElement) {
      fullScreenElement = modDocument.mozFullScreenElement;
    } else if (modDocument.msCurrentFullScreenElement) {
      fullScreenElement = modDocument.msCurrentFullScreenElement;
    }
    return fullScreenElement;
  },
  requestFullScreenExit: async () => {
    let result;
    const modifiedDoc: CrossBrowserFullScreenableDocument = document;
    if (modifiedDoc.exitFullscreen) {
      result = await modifiedDoc.exitFullscreen();
    } else if (modifiedDoc.msExitFullscreen) {
      result = await modifiedDoc.msExitFullscreen();
    } else if (modifiedDoc.mozExitFullScreen) {
      result = await modifiedDoc.mozExitFullScreen();
    } else if (modifiedDoc.webkitExitFullscreen) {
      result = modifiedDoc.webkitExitFullscreen();
    } else {
      result = 'Fullscreen API is not supported';
    }
    return result;
  },
  requestFullScreen: async (element: CrossBrowserFullScreenableElement) => {
    let result;
    if (element.requestFullscreen) {
      result = await element.requestFullscreen();
    } else if (element.msRequestFullscreen) {
      result = element.msRequestFullscreen();
    } else if (element.mozRequestFullScreen) {
      result = element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      result = element.webkitRequestFullscreen();
    } else {
      result = 'Fullscreen API is not supported';
    }
    return result;
  },
};

export default CrossBrowserFullScreenUtils;
